// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1GetUserGaDataLayerDataModel,
  IMappers,
  TCianApiSiteV1GetUserGaDataLayerDataResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUserGaDataLayerResponseSchema35 } from '../../../../entities/views/UserGaDataLayerResponseSchema35';

export function createCianApiSiteV1GetUserGaDataLayerDataModel(): TCianApiSiteV1GetUserGaDataLayerDataModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/get-user-ga-data-layer-data/',
    response: {
      '200': {
        contentType: 'json',
      },
    },
  };
}

export interface ICianApiSiteV1GetUserGaDataLayerDataOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchCianApiSiteV1GetUserGaDataLayerData<TResponse200>({
  httpApi,
  config,
  mappers,
}: ICianApiSiteV1GetUserGaDataLayerDataOptions<TResponse200>): Promise<
  FetchResponse<TCianApiSiteV1GetUserGaDataLayerDataResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1GetUserGaDataLayerDataModel(),
    config,
  )) as FetchResponse<TCianApiSiteV1GetUserGaDataLayerDataResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUserGaDataLayerResponseSchema35, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1GetUserGaDataLayerDataResponse>;
}
